import React from 'react';

import { observer } from 'mobx-react';
import { Alert } from '@infoods/lifebase-ui';

import { UseStepperReturn } from '../../../../../shared/hooks/useStepper';
import {
  ButtonRow,
  CoachCard,
} from '../../../../components/customer-self-setup-components';
import { SelectSubscriptionBlock } from '../../../../../payment';
import { coachStore } from '../../../../stores/customerSelfSetupStores/coachStore';
import { personalInfoStore } from '../../../../stores/customerSelfSetupStores/personalInfoStore';
import { getPriceView } from '../../../../../shared/utils/stringUtils';
import { useScrollToTop } from '../../../../../shared/hooks/useScrollToTop';
import { useSignUpSubscriptions } from '../../../../hooks/customerSelfSetupHooks/useSignUpSubscriptions';
import { CONSULTATION_TYPE } from '../../../../../shared/constants/coach/consultationType';

type SelectSubscriptionStepProps = {
  stepperMethods: UseStepperReturn;
};

const SelectSubscriptionStep = observer(
  ({ stepperMethods }: SelectSubscriptionStepProps) => {
    useScrollToTop();

    const { selectedCoach, consultationType } = coachStore;
    const { customerData } = personalInfoStore;

    const {
      subscriptions,
      discountPercent,
      selectedSubscription,
      isNonPaidSubscription,
      applyPromoCode,
      setSelectedSubscriptionId,
      handleSubmit,
    } = useSignUpSubscriptions({
      entityId: selectedCoach!.entityId,
      customerEmail: customerData!.email,
      consultationType: consultationType!,
    });

    const nonPaidYesButtonText = 'Submit Form';

    const yesButtonText = `Submit Form & Pay ${
      selectedSubscription ? getPriceView(selectedSubscription.initialPlanPriceFinal) : ''
    }`;

    return (
      <div>
        {selectedCoach && (
          <CoachCard coachInfo={selectedCoach} consultationType={consultationType} />
        )}
        <SelectSubscriptionBlock
          subscriptions={subscriptions}
          discountPercent={discountPercent}
          onApplyPromoCode={applyPromoCode}
          selectedSubscriptionId={selectedSubscription?.id || null}
          setSelectedSubscriptionId={setSelectedSubscriptionId}
          titleDescription="Access to the SWYMO app starts when your coach finalizes your setup and custom macro plan"
          extraInfo={
            consultationType === CONSULTATION_TYPE.REMOTE && (
              <Alert severity="info" size="small">
                The cost of the scale is not included in the subscription price
              </Alert>
            )
          }
        />
        <ButtonRow
          yesHandler={handleSubmit}
          yesText={isNonPaidSubscription ? nonPaidYesButtonText : yesButtonText}
          yesDisabled={!selectedSubscription}
          noHandler={stepperMethods.goToPreviousStep}
        />
      </div>
    );
  },
);

export { SelectSubscriptionStep };
